'use client'

import React from 'react'
import styles from './styles.module.scss'
import TrashSvg from '@/src/assets/svgs/collection/trash.svg'

interface Props {
    name: string,
    remove: () => void,
    className?: string
}

export default function RemoveCoupon({ name, remove, className }: Props) {
    return (
        <div className={`${styles.removeCouponArea} ${className ?? ""}`}>{name} <TrashSvg className={styles.removeCoupon} onClick={remove} /></div>
    )
}
